// Import blog images
import fm from "front-matter";
import firstBlogImage from "../assets/images/blogs/blog1.png";
import secondBlogImage from "../assets/images/blogs/blog2.png";
import thirdBlogImage from "../assets/images/blogs/blog3.png";

export async function fetchAllBlogs() {
  return [
    {
      slug: "legal-position-on-ai-based-note-taking-apps",
      title: "Legal Position on AI-Based Note Taking Apps",
      description: "The use of AI-based note taking apps during board and committee meetings conducted through video conferencing in India involves a complex legal framework",
      date: "February 19, 2026",
      url: "/blogs/first-blog.md",
      image: firstBlogImage,
    },
    {
      slug: "Requirements-of-NFRA-Circular-date-7th-January-2026",
      title: "Requirements of NFRA Circular date 7th January 2026",
      description: "The NFRA circular NF-25013/3/2025-NFRA, dated January 7, 2026.",
      date: "February 25, 2026",
      url: "/blogs/second-blog.md",
      image: secondBlogImage,
    },
    {
      slug: "NFRAs-expectations-from-Audit-Committees",
      title: "NFRA’s expectations from Audit Committees",
      description: "A summary of NFRA's tightening stance on audit quality",
      date: "March 10, 2026",
      url: "/blogs/third-blog.md",
      image: thirdBlogImage,
    },
  ];
}

// Updated fetchBlogContent to parse front matter in browser
export async function fetchBlogContent(url) {
  const res = await fetch(url);
  const text = await res.text();

  // Parse front matter using front-matter (browser compatible)
  const parsed = fm(text);

  // parsed.body = markdown content
  // parsed.attributes = front matter (title, date, description, slug)
  return { content: parsed.body, data: parsed.attributes };
}
